import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants';
import {
  BackResponseFailure,
  BaseBackResponse,
} from '@savgroup-front-common/types';

import { prepareResponseFailure } from '../../helpers';
import { ApiRequestDescriptor, executeQuery } from '../../services';

const ENDPOINT = `${APIConfiguration.claim}claims`;

export interface DeleteClaimReasonAdditionalInformationFileCommandArgs {
  claimId: string;
  additionalInformationId: string;
  blobValue: string;
}

export const deleteClaimReasonAdditionalInformationFileRequest = ({
  claimId,
  additionalInformationId,
  blobValue,
}: DeleteClaimReasonAdditionalInformationFileCommandArgs): ApiRequestDescriptor => ({
  url: `${ENDPOINT}/${claimId}/additionalInformation/${additionalInformationId}/file`,
  config: {
    method: SUPPORTED_METHODS.DELETE,
    json: { blobName: blobValue },
  },
});

export const deleteClaimReasonAdditionalInformationFileCommand = async (
  args: DeleteClaimReasonAdditionalInformationFileCommandArgs,
): Promise<BaseBackResponse | BackResponseFailure> => {
  try {
    return await executeQuery<BaseBackResponse>(
      deleteClaimReasonAdditionalInformationFileRequest(args),
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
};
